'use client';

import Conversations from '@/components/account/home/Conversations';
import { InterviewsTable } from '@/components/account/interview/InterviewsTable';
import { Heading } from '@/components/catalyst/heading';
import { useWorkspace } from '@/utils/clerk/client';

export default function AccountHome() {
  const { workspace } = useWorkspace();

  return (
    <div className="space-y-4 p-2 lg:p-6 lg:py-4">
      <div className="mb-2 flex w-full flex-wrap items-end justify-between gap-4 ">
        <Heading level={1}>{workspace?.name}</Heading>
      </div>
      <div className="pb-8">
        <InterviewsTable limit={10} />
      </div>

      <Conversations />
    </div>
  );
}
